// Dados da busca do talão — máscaras e validação, tudo no navegador.
// Nada aqui é guardado em lugar nenhum: só vive na memória enquanto a pessoa
// está na tela.

// Só os dígitos, para mandar ao banco.
export function somenteDigitos(valor: string): string {
  return valor.replace(/\D/g, '');
}

// Máscara do CPF: 000.000.000-00.
export function mascararCpf(valor: string): string {
  const d = somenteDigitos(valor).slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

// Máscara da data: DD/MM/AAAA.
export function mascararData(valor: string): string {
  const d = somenteDigitos(valor).slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
}

export function cpfCompleto(valor: string): boolean {
  return somenteDigitos(valor).length === 11;
}

export function dataCompleta(valor: string): boolean {
  return somenteDigitos(valor).length === 8;
}

// Converte DD/MM/AAAA em AAAA-MM-DD. Retorna null se a data não existir
// (31/02, mês 13, ano maluco) ou estiver no futuro.
export function dataParaIso(valor: string): string | null {
  const d = somenteDigitos(valor);
  if (d.length !== 8) return null;

  const dia = Number(d.slice(0, 2));
  const mes = Number(d.slice(2, 4));
  const ano = Number(d.slice(4));

  if (ano < 1900 || ano > 2100) return null;
  if (mes < 1 || mes > 12) return null;
  if (dia < 1 || dia > 31) return null;

  const dt = new Date(ano, mes - 1, dia);
  if (dt.getFullYear() !== ano || dt.getMonth() !== mes - 1 || dt.getDate() !== dia) {
    return null;
  }

  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  if (dt.getTime() > hoje.getTime()) return null;

  return `${String(ano).padStart(4, '0')}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
}